module.exports = __webpack_public_path__ + "img/66.fb0dc937.jpg";